import type { TimerSpan } from "@/v2/hooks/useSmartTimer";

type DisplaySpan = Pick<
	TimerSpan,
	"startedAt" | "startingDurationSeconds" | "billingIncrementSeconds"
>;

export function timerDisplaySeconds(
	span: DisplaySpan | null | undefined,
	nowMs: number,
): number {
	if (!span) return 0;
	return (
		span.startingDurationSeconds +
		Math.max(0, Math.floor((nowMs - Date.parse(span.startedAt)) / 1000))
	);
}

export function timerDisplayUnits(
	span: DisplaySpan | null | undefined,
	nowMs: number,
): number {
	if (!span) return 0;
	const seconds = timerDisplaySeconds(span, nowMs);
	// Preserve the exact saved units at start, including zero and manual values
	// off the billing grid. Once time accrues, use the server's settlement grid.
	const billableSeconds =
		seconds === span.startingDurationSeconds
			? seconds
			: Math.ceil(seconds / span.billingIncrementSeconds) *
				span.billingIncrementSeconds;
	return billableSeconds / 3600;
}
